import o from "axios";
import t from "./request-interceptor/bearer-token-interceptor.js";
import p from "./request-interceptor/x-traceid-interceptor.js";
import i from "./request-interceptor/api-key-interceptor.js";
import a from "./request-interceptor/accept-language-interceptor.js";
import c from "./request-interceptor/url-interceptor.js";
import f from "./request-interceptor/caller-interceptor.js";
import s from "./request-interceptor/origin-interceptor.js";
import { env as m } from "../envManager.js";
const r = o.create({});
c(r, m.generateGetter("apiAccorComApi"));
t(r);
p(r);
i(r);
s(r);
f(r);
a(r);
const e = o.create({
  // param serializer is to avoid the encoding of axios who is not efficient in wccgw
  paramsSerializer: (n) => new URLSearchParams(n)
});
c(e, m.generateGetter("apiWcgwAwsAccorComApi"));
t(e);
p(e);
i(e);
a(e);
export {
  r as axiosApi,
  e as axiosWcgw
};
//# sourceMappingURL=axiosApi.js.map
